export default __webpack_public_path__ + "static/media/O-062.ab743554.png";